import {
  SET_CURRENT_STEP,
  SET_COMPLETED_STEPS,
  STEP_SET_COMPLETED,
  STEPS_SET_LAST_STEP_ID,
  STEP_SET_ALTERNATIVE_DESIGNS_STATE
} from "./mutations.type";
import {
  GO_NEXT_STEP,
  GO_PREVIOUS_STEP,
  GO_STEP,
  RESET_ALTERNATIVE_DESIGNS_STATE
} from "./actions.type";

import RoeUploadParticipantsForm from '@/components/report-edit-steps/UploadParticipants';
import RoeBasicDataForm from '@/components/report-edit-steps/BasicData';
import RoeReportBetterRetirementOutcomes from '@/views/ReportBetterRetirementOutcomes';
import RoeEligibilityForm from "@/components/report-edit-steps/Eligibility";
import RoeEmployeeContributionsForm from "@/components/report-edit-steps/EmployeeContributions";
import RoeEmployerContributionMatchForm from "@/components/report-edit-steps/EmployerContributionMatch";
import RoeEmployerContributionOtherForm from "@/components/report-edit-steps/EmployerContributionOther";
import RoeInvestmentsForm from "@/components/report-edit-steps/Investments";
import RoeLoansForm from "@/components/report-edit-steps/Loans";
import RoeWithdrawalsForm from "@/components/report-edit-steps/Withdrawals";
import RoeDistributionsForm from "@/components/report-edit-steps/Distributions";
import RoeOtherBenefitPlansForm from "@/components/report-edit-steps/OtherBenefitPlans";

const STEPS = [
  {
    id: 0,
    name: 'report-introduction',
    step: 'report-introduction'
  },
  {
    id: 1,
    name: 'report-edit',
    component: RoeEligibilityForm,
    title: "Eligibility",
    step: "eligibility"
  },
  {
    id: 2,
    name: 'report-edit',
    component: RoeEmployeeContributionsForm,
    title: "Employee Contributions",
    step: "employee-contributions"
  },
  {
    id: 3,
    name: 'report-edit',
    component: RoeEmployerContributionMatchForm,
    title: "Employer Contribution Match",
    step: "employer-contribution-match",
  },
  {
    id: 4,
    name: 'report-edit',
    component: RoeEmployerContributionOtherForm,
    title: "Employer Contribution Other",
    step: "employer-contribution-other",
  },
  {
    id: 5,
    name: 'report-edit',
    component: RoeInvestmentsForm,
    title: "Investments",
    step: "investments",
  },
  {
    id: 6,
    name: 'report-edit',
    component: RoeLoansForm,
    title: "Loans",
    step: "loans",
  },
  {
    id: 7,
    name: 'report-edit',
    component: RoeWithdrawalsForm,
    title: "Withdrawals",
    step: "withdrawals",
  },
  {
    id: 8,
    name: 'report-edit',
    component: RoeDistributionsForm,
    title: "Distributions",
    step: "distributions",
  },
  {
    id: 9,
    name: 'report-edit',
    component: RoeOtherBenefitPlansForm,
    title: "Other Benefit Plans",
    step: "other-benefit-plans",
  },
  {
    id: 10,
    name: 'report-participants',
    component: RoeUploadParticipantsForm,
    title: "Load Data",
    step: "load-data",
  },
  {
    id: 11,
    name: 'report-participants',
    component: RoeBasicDataForm,
    title: "Choose Comp Segments",
    step: "basic-data"
  },
  {
    id: 12,
    name: 'report-participants',
    component: RoeReportBetterRetirementOutcomes,
    title: "Better Outcomes",
    step: "better-outcomes",
  },
  {
    id: 13,
    name: 'report-alternative-designs',
    step: 'report-alternative-designs'
  },
  {
    id: 14,
    name: 'report-download',
    step: 'report-download',
    disableNextAction: true
  }
];

const state = {
  currentStep: {},
  steps: STEPS,
  lastStepId: 0
};

const getters = {
  currentStep(state) {
    return state.currentStep;
  },
  steps(state) {
    return state.steps;
  },
  lastStepId(state) {
    return state.lastStepId;
  },
  canGoToStep(state) {
    return function(step, isNotAllowedCurrent = true) {
      if(step.id === state.currentStep.id && isNotAllowedCurrent) return false;
      if(step.state === 'completed') return true;
      let isNextStep = state.steps.find((s) => s.state === 'completed' && step.id - 1 === s.id);
      return !!isNextStep || step.id - 1 === state.currentStep.id && state.currentStep.id !== 13;
    };
  },
  stepByStepName(state) {
    return function (stepName) {
      return state.steps.find((s) => { return s.step === stepName });
    };
  },
  isNextStepsCompleted(state) {
    let nextCompletedStep = state.steps.find((step) => state.currentStep.id + 1 === step.id && step.state === 'completed');
    return !!nextCompletedStep;
  }
};

const actions = {
  [GO_NEXT_STEP]({state, commit}) {
    let nextStep = state.steps[state.steps.indexOf(state.currentStep) + 1];
    if(state.currentStep.id < 13) commit(STEP_SET_COMPLETED);
    commit(SET_CURRENT_STEP, nextStep);
    commit(STEPS_SET_LAST_STEP_ID, state.currentStep.id);
  },
  [GO_PREVIOUS_STEP](context) {
    let prevStep = context.state.steps[context.state.steps.indexOf(context.state.currentStep) - 1];
    context.commit(SET_CURRENT_STEP, prevStep);
  },
  async [GO_STEP](context, step) {
    if(context.state.currentStep.id < 13) context.commit(STEP_SET_COMPLETED);
    context.commit(SET_CURRENT_STEP, step);
    context.commit(STEPS_SET_LAST_STEP_ID, context.state.currentStep.id);
  },
  [RESET_ALTERNATIVE_DESIGNS_STATE]({state, commit}) {
    if(state.currentStep.id < 13) commit(STEP_SET_ALTERNATIVE_DESIGNS_STATE, false);
  }
};

const mutations = {
  [SET_CURRENT_STEP](state, step) {
    if(step === undefined) {
      state.currentStep = {};
      state.steps = STEPS;
    } else {
      state.currentStep = step;
    }
  },
  [SET_COMPLETED_STEPS](state, lastStepId) {
    if(lastStepId) state.lastStepId = lastStepId;
    state.steps.forEach((step) => {
      step.state = step.id < state.lastStepId || step.id === 0 ? 'completed' : null;
    });
  },
  [STEP_SET_COMPLETED](state) {
    state.currentStep.state = 'completed';
  },
  [STEPS_SET_LAST_STEP_ID](state, lastStepId) {
    if(state.lastStepId < lastStepId) state.lastStepId = lastStepId;
  },
  [STEP_SET_ALTERNATIVE_DESIGNS_STATE](state, isCalculated) {
    if(isCalculated) {
      state.steps[13].state = 'completed';
      state.steps[14].state = 'completed';
      state.lastStepId = 15;
    } else {
      state.steps[13].state = null;
      state.steps[14].state = null;
      if(state.lastStepId > 13) state.lastStepId = 13;
    }
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
